var map = {
	"./arabic.json": 652,
	"./bulgarian.json": 653,
	"./czech.json": 654,
	"./denmark.json": 655,
	"./english.json": 656,
	"./finnish.json": 657,
	"./greek.json": 658,
	"./indonesian.json": 659,
	"./malay.json": 660,
	"./norwegian.json": 661,
	"./romanian.json": 662,
	"./slovakia.json": 663,
	"./swedish.json": 664,
	"./thai.json": 665
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2468;


//////////////////
// WEBPACK FOOTER
// ./src/locales/gamebox [A-Za-z0-9-_,\s]+\.json$/
// module id = 2468
// module chunks = 0